// Lib Area
var addMethodVisible = function(){
	(function($){
        $.fn.visible = function(partial){

            var $t				= $(this),
                $w				= $(window),
                viewTop			= $w.scrollTop(),
                viewBottom		= viewTop + $w.height(),
                _top			= $t.offset().top,
                _bottom			= _top + $t.height(),
                compareTop		= partial === true ? _bottom : _top,
                compareBottom	= partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

    })(jQuery);
}
// Compare Array
// Warn if overriding existing method
if(Array.prototype.equals)
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
    // if the other array is a falsy value, return
    if (!array)
        return false;

    // compare lengths - can save a lot of time
    if (this.length != array.length)
        return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i]))
                return false;
        }
        else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}
// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});

var  arraysEqual = function(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length != b.length) return false;

  // If you don't care about the order of the elements inside
  // the array, you should sort both arrays here.
  // Please note that calling sort on an array will modify that array.
  // you might want to clone your array first.

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

var loadScript = function(url, callback, errcallback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) { // If the browser is Internet Explorer.
        script.onreadystatechange = function() {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
        setTimeout(function() {
            if (script.onreadystatechange !== null) {
                if (errcallback !== undefined) errcallback();
            }
        }, 3000);
    } else { // For any other browser.
        script.onload = function() {
            callback();
        };
        script.onerror = function() {
            if (errcallback !== undefined) errcallback();
        }
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};


InitSelector = function() {
        //   Custom Select
        var p, x, i, j, selElmnt, a, b, c;
        /*look for any elements with the class "custom-select":*/
        p = $('.g-stickybar[selected]')[0];
        x = p.getElementsByClassName("custom-select");
        for (i = 0; i < x.length; i++) {
            selElmnt = x[i].getElementsByTagName("select")[0];
            // Remove old select
            $(selElmnt).parent().find('.select-selected').remove();
            $(selElmnt).parent().find('.select-items').remove();
            /*for each element, create a new DIV that will act as the selected item:*/
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            if (selElmnt.selectedIndex == -1) selElmnt.selectedIndex = 0;
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            x[i].appendChild(a);
            /*for each element, create a new DIV that will contain the option list:*/
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");
            for (j = 0; j < selElmnt.length; j++) {
                /*for each option in the original select element,
                create a new DIV that will act as an option item:*/
                c = document.createElement("DIV");
                c.innerHTML = selElmnt.options[j].innerHTML;
                c.addEventListener("click", function(e) {
                    /*when an item is clicked, update the original select box,
                    and the selected item:*/
                    var y, i, k, s, h;
                    s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                    h = this.parentNode.previousSibling;
                    for (i = 0; i < s.length; i++) {
                        if (s.options[i].innerHTML == this.innerHTML) {
                            s.selectedIndex = i;
                            h.innerHTML = this.innerHTML;
                            y = this.parentNode.getElementsByClassName("same-as-selected");
                            for (k = 0; k < y.length; k++) {
                                y[k].removeAttribute("class");
                            }
                            this.setAttribute("class", "same-as-selected");
                            break;
                        }
                    }
                    h.click();
                });
                b.appendChild(c);
            }
            x[i].appendChild(b);
          	var before_change,after_change
            a.addEventListener("click", function(e) {
                /*when the select box is clicked, close any other select boxes,
                and open/close the current select box:*/
                if(!$(this).hasClass('select-arrow-active'))
                	before_change = $(this).closest('.custom-select').find('select').val()
                else
                    after_change = $(this).closest('.custom-select').find('select').val()

                if(typeof before_change !== 'undefined' && typeof after_change !== 'undefined' && before_change != after_change){
                	$(this).closest('.custom-select').find('select').change();
                }
                e.stopPropagation();
                closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");

            });
        }

        function closeAllSelect(elmnt) {
            /*a function that will close all select boxes in the document,
            except the current select box:*/
            var x, y, i, arrNo = [];
            x = document.getElementsByClassName("select-items");
            y = document.getElementsByClassName("select-selected");
            for (i = 0; i < y.length; i++) {
                if (elmnt == y[i]) {
                    arrNo.push(i)
                } else {
                    y[i].classList.remove("select-arrow-active");
                }
            }
            for (i = 0; i < x.length; i++) {
                if (arrNo.indexOf(i)) {
                    x[i].classList.add("select-hide");
                }
            }
        }
        /*if the user clicks anywhere outside the select box,
        then close all select boxes:*/
        document.addEventListener("click", closeAllSelect);
    }


setCookie = function(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
eraseCookie = function(name) {
    document.cookie = name+'=; Max-Age=-99999999;';
}





money_format = GOCCConfigs.money_format
formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

promise_ajax = async function(url){
  	return new Promise((resolve, reject) => {
    $.ajax(url, {
        type: "GET",
        complete: function(result) {
            resolve(result)
        }
    });
  })
}
deparam = function (query) {
  var pairs, i, keyValuePair, key, value, map = {};
  // remove leading question mark if its there
  if (query.slice(0, 1) === '?') {
    query = query.slice(1);
  }
  if (query !== '') {
    pairs = query.split('&');
    for (i = 0; i < pairs.length; i += 1) {
      keyValuePair = pairs[i].split('=');
      key = decodeURIComponent(keyValuePair[0]);
      value = (keyValuePair.length > 1) ? decodeURIComponent(keyValuePair[1]) : undefined;
      map[key] = value;
    }
  }
  return map;
}
getValueFromObject = function(obj, id, field){
  var value = '';
  if (obj.length) {
    $.each(obj, function(k, item) {
      if (item.id == id) {
        value = item[field];
      }
    });
  }
  return value;
}
getPageType = function(){
    var url = window.location.toString();
    if(url.match(/\/products\//) !== null || url.match(/\/products_preview/) !== null){
      return 'product';
    }else if(url.match(/\/cart/) !== null){
      return 'cart';
    }else if(url.match(/\/collections\//) !== null){
      return 'collection';
    }else if(url.match(/\/account/) !== null){
      return 'account';
    }else if(url.match(/\/pages\//) !== null){
        return 'page';
    }else if(url.match(/\/search\?/) !== null){
      return 'search';
    }else{
      return '';
    }
  };

createEvent = function(evtName,state) {
var evt = $.Event(evtName);
evt.state = state;

$(window).trigger(evt);
}

browser_width = window.innerWidth
|| document.documentElement.clientWidth
|| document.body.clientWidth;

browser_height = window.innerHeight
|| document.documentElement.clientHeight
|| document.body.clientHeight;


stickybarDisplay = function(){


    // Responsive
    /* if($('.g-stickybar[selected] .custom-select').length > 1){
            var w_with = $(document).width()
            var bar_action = $('.g-stickybar .item.bar-action')
            var item_option = $('.g-stickybar .option')
            var quantity = $('.g-stickybar .item.quantity')
            var price = $('.g-stickybar .g-price')
            if(browser_width <= 480){
                $(bar_action).css('flex-grow','unset')
                $(bar_action).css('order','unset')
                $(item_option).css('order','2')
                $(quantity).hide()
                $(price).hide()
            }
        } */




      applyConditionDisplay()
      $(window).on('scroll', function() {
      		applyConditionDisplay()
      })
}
function applyConditionDisplay(){
    if($(GOCCConfigs.selector.addtocart_selector).filter(':visible').length > 0 ){
    	var data_display = $('.g-stickybar').attr('data-display');
        var scrollTop_enable = typeof GOCCConfigs.scrollTop !== 'undefined' ? true : false
        var scrollTop = typeof GOCCConfigs.scrollTop !== 'undefined' ? GOCCConfigs.scrollTop : 0
        var atc_is_visible = $(GOCCConfigs.selector.addtocart_selector).filter(':visible').visible()
        var eTop = $(GOCCConfigs.selector.addtocart_selector).filter(':visible').offset().top;
        var cTop = $(window).scrollTop()

        var atc_display = false

        if(data_display == 'alwayshow' && scrollTop_enable && cTop >= scrollTop) atc_display = true
        if(data_display == 'alwayshow' && scrollTop_enable && cTop < scrollTop ) atc_display = false
        if(data_display == 'alwayshow' && !scrollTop_enable ) atc_display = true

        if(data_display == 'addtocart_is_not_visible' && scrollTop_enable && cTop >= scrollTop && !atc_is_visible) atc_display = true
        if(data_display == 'addtocart_is_not_visible' && !scrollTop_enable && !atc_is_visible ) atc_display = true
        if(data_display == 'addtocart_is_not_visible' && atc_is_visible ) atc_display = false

        if(data_display == 'down_and_surpass_addtocart' && eTop < cTop && !atc_is_visible) atc_display = true
        if(data_display == 'down_and_surpass_addtocart' && eTop >= cTop ) atc_display = false
        if(atc_display){
            $('.g-stickybar').css('display', 'flex')
            createEvent('globo_stickybar',{display:true})
        }else{
            $('.g-stickybar').css('display', 'none')
            createEvent('globo_stickybar',{display:false})
        }
    }

}
